module.exports = __webpack_public_path__ + "img/0Q3A3452_L_WoodMatted_MockedUp.6a9adda0.jpg";